module.exports = __webpack_public_path__ + "img/Mietzekatze.9af8ed97.svg";